// @storybook-internal widget renderer catalogued through PlacedWidgetItem.
import React from "react";
import "./widget-cards.css";

import type { T_ChatV8PortfolioRatingWidgetData } from "@lattice/core-lib/types/chat-v8";

export type T_PortfolioRatingCardProps = {
  data: T_ChatV8PortfolioRatingWidgetData;
};

/**
 * Portfolio rating grade card (RAI-1092): web counterpart of the mobile
 * verdict presentation. Renders INSTEAD of the fallback table when the
 * artifact carries the portfolio_rating presentation.
 *
 * Owns only the graded metric rows — verdict, main issue, suggestion, and
 * follow-ups stay in the flow's markdown blocks, mirroring what the fallback
 * table shows old clients.
 */
export function PortfolioRatingCard({ data }: T_PortfolioRatingCardProps) {
  // No card title: the flow's markdown already emits the
  // "## Portfolio rating" heading directly above this artifact.
  return (
    <section aria-label="Portfolio rating" className="cw-rating">
      <ul className="cw-rating__metrics">
        {data.metrics.map((metric) => (
          <li className="cw-rating__metric" key={metric.label}>
            <div className="cw-rating__metric-copy">
              <span className="cw-rating__metric-label">{metric.label}</span>
              <span className="cw-rating__metric-sublabel">
                {metric.sublabel}
              </span>
            </div>
            <span
              className={`cw-rating__badge cw-rating__badge--${metric.badgeTone}`}
            >
              {metric.badgeValue}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
